export const Envs = {
  BFF_WEB_URL: process.env['NEXT_PUBLIC_HUB_API'] ?? process.env['REACT_APP_HUB_API'] ?? process.env['NX_BFF_WEB_URL'],
  FUNCTIONS_URL: process.env['NX_FUNCTIONS_URL'] ?? process.env['REACT_APP_FUNCTIONS_URL'],
  RECAPTCHA_KEY: process.env['NX_RECAPTCHA_KEY'] ?? process.env['REACT_APP_RECAPTCHA'] ?? '',
  TERMS_OF_USE: process.env['NX_TERMS_OF_USE'] ?? process.env['REACT_APP_TERMS_OF_USE'],
  PRIVACY_POLICY: process.env['NX_PRIVACY_POLICY'] ?? process.env['REACT_APP_PRIVACY_POLICY'],
  NODE_ENV: process.env['NODE_ENV'] ?? 'development',
}
